export default "<p>hulk-config-poplist-edit works!</p>\n"